import { Controller } from "@hotwired/stimulus"

// Support's customer view (QA #33): on a page the customer alone may change,
// every form is disabled, so nothing is typed that the server would refuse.
export default class extends Controller {
  connect() {
    this.element.querySelectorAll("form").forEach((form) => {
      if ((form.getAttribute("method") || "get").toLowerCase() === "get") return

      form.querySelectorAll("input, select, textarea, button").forEach((field) => {
        if (field.type === "hidden") return
        field.disabled = true
      })
      form.classList.add("opacity-60")
    })
  }
}
